import SignOutRedirect from '@/components/auth/SignOutRedirect';

export default function SignOut() {
	return (
		<>
			<SignOutRedirect />
		</>
	);
}
